/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attributes_Status_DraftInputs */

const en_attributes_status_draft = /** @type {(inputs: Attributes_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Being filled in`)
};

/**
* | output |
* | --- |
* | "Being filled in" |
*
* @param {Attributes_Status_DraftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attributes_status_draft = /** @type {((inputs?: Attributes_Status_DraftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attributes_Status_DraftInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attributes_status_draft(inputs)
});